import type { OngoingCall, CustomInputField, Operator } from '../../models/amplify/API';

export type OngoingCallView = {
  callSid: string;
  callId?: string | null;
  pin?: string | null,
  callStartedAt?: string | null;    
  callStatus?: string | null;
  clientNumber?: string | null;
  durationMilliseconds?: number | null;
  languageName?: string | null;
  outboundPhoneNumbers?: string[] | null;
  customInputFields?: CustomInputField[] | null;
  operators?: Operator[] | null;
};

export function nonNull<T>(x: T | null | undefined): x is T {
  return x != null;
}

export function normalizeCall(raw: OngoingCall | null | undefined): OngoingCallView | null {
  if (!raw || !raw.callSid) return null;

  return {
    callSid: raw.callSid,
    callId: raw.callId ?? null,
    pin: raw.pin ?? null,
    callStartedAt: raw.callStartedAt ?? null,      
    callStatus: raw.callStatus ?? null,
    clientNumber: raw.clientNumber ?? null,
    durationMilliseconds: raw.durationMilliseconds ?? null,
    languageName: raw.languageName ?? null,
    outboundPhoneNumbers: raw.outboundPhoneNumbers?.filter(nonNull) ?? null,
    customInputFields: raw.customInputFields?.filter(nonNull) ?? null,
    operators: raw.operators?.filter(nonNull) ?? null,
  };
}
